import { render, staticRenderFns } from "./registerInfo.vue?vue&type=template&id=52bf0079&scoped=true&"
import script from "./registerInfo.vue?vue&type=script&lang=js&"
export * from "./registerInfo.vue?vue&type=script&lang=js&"
import style0 from "./registerInfo.vue?vue&type=style&index=0&id=52bf0079&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf0079",
  null
  
)

export default component.exports